"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MediaQueryService {
    constructor() {
        this.breakpoints = {
            XSmall: '(max-width: 599.99px)',
            Small: '(min-width: 600px) and (max-width: 959.99px)',
            Medium: '(min-width: 960px) and (max-width: 1279.99px)',
            Large: '(min-width: 1280px)'
        };
        this.xSmallMedia = window.matchMedia(this.breakpoints.XSmall);
        this.smallMedia = window.matchMedia(this.breakpoints.Small);
        this.mediumMedia = window.matchMedia(this.breakpoints.Medium);
        this.largeMedia = window.matchMedia(this.breakpoints.Large);
        this.handlers = [];
        this.sizes = {
            'screen-x-small': this.xSmallMedia.matches,
            'screen-small': this.smallMedia.matches,
            'screen-medium': this.mediumMedia.matches,
            'screen-large': this.largeMedia.matches
        };
    }
    subscribe(handler) {
        this.handlers.push(handler);
        this.addMediaListeners();
    }
    unsubscribe(handler) {
        this.handlers = this.handlers.filter(item => item !== handler);
        this.removeMediaListener(handler);
    }
    addMediaListeners() {
        [this.xSmallMedia, this.smallMedia, this.mediumMedia, this.largeMedia].forEach(media => {
            media.addListener(() => {
                this.handlers.forEach(handler => handler());
            });
        });
    }
    removeMediaListener(handler) {
        [this.xSmallMedia, this.smallMedia, this.mediumMedia, this.largeMedia].forEach(media => {
            media.removeListener(handler);
        });
    }
}
exports.MediaQueryService = MediaQueryService;
//# sourceMappingURL=MediaQueryService.js.map